import {onUnmounted} from 'vue'

export default function useInterval(fn, time) {
  let id = setInterval(fn, time)
  onUnmounted(() => clearInterval(id))
  return id
}
